// French for SourcesPage (BUILD-BRIEF-R6 §5.1, §5.5). §5.5's own table is used verbatim for the
// rows it names; everything else this page adds is translated in the same register.
import { registerFr } from '../i18n/index.js';

registerFr({
  // §5.5, verbatim
  'Sources': 'Sources',
  'What the record reads': 'Ce que le dossier lit',
  'Refresh all': 'Tout actualiser',
  'Refresh now': 'Actualiser maintenant',
  'Documents': 'Documents',
  'Changed at last check': 'Modifiées au dernier contrôle',
  'disabled': 'désactivée',
  'parser not built yet': 'parseur pas encore construit',
  'no_parser': 'parseur pas encore construit',
  'Entries': 'Entrées',
  'Series points': 'Points de série',
  'Refreshes': 'Actualisations',
  'Waiting': 'En attente',
  'Propose': 'Proposer',
  'kept · no series named': 'conservé · aucune série nommée',
  'unchanged': 'inchangé',
  'changed': 'modifié',
  'refused': 'refusé',
  'daily · {signal}': 'quotidien · {signal}',
  'Every vintage kept; the newest is what the parsers read': 'Chaque version est conservée ; les parseurs lisent la plus récente',

  // this page's own additions
  'sources': 'sources',
  'documents kept': 'documents conservés',
  'last refresh': 'dernière actualisation',
  'of {n}': 'sur {n}',
  '{n} superseded': '{n} remplacé(s)',
  'by the latest refresh of each': "d'après la dernière actualisation de chacune",
  '{resolved} on the record · {open} waiting': '{resolved} au dossier · {open} en attente',
  '{n} series': '{n} séries',
  'counting…': 'décompte…',
  'Source': 'Source',
  'kind': 'type',
  'cadence': 'rythme',
  'detection': 'détection',
  'status': 'statut',
  'last checked': 'dernier contrôle',
  'last changed': 'dernière modification',
  'filed': 'déposé',
  'next check': 'prochain contrôle',
  'per document': 'par document',
  'Disable this source': 'Désactiver cette source',
  'Enable this source': 'Activer cette source',
  'Open in Review': 'Ouvrir dans Revue',
  'No source registered yet.': 'Aucune source enregistrée pour l’instant.',
  'Could not load the sources: {error}': 'Impossible de charger les sources : {error}',
  'Loading…': 'Chargement…',
  'source': 'source',
  'filename': 'fichier',
  'version': 'version',
  'Last-Modified': 'Last-Modified',
  'sha256': 'sha256',
  'fetched': 'récupéré',
  'parsed': 'lu',
  'No document fetched yet.': 'Aucun document récupéré pour l’instant.',
  'Could not load the documents: {error}': 'Impossible de charger les documents : {error}',
  'superseded': 'remplacé',
  'show the previous vintage': 'afficher la version précédente',
  'show': 'afficher',
  'hide': 'masquer',
  'when': 'quand',
  'outcome': 'résultat',
  'documents new': 'documents nouveaux',
  'entries added/gone': 'entrées ajoutées/disparues',
  'points new/superseded': 'points nouveaux/remplacés',
  'claims filed/held/waiting': 'déposées/tenues/en attente',
  'report': 'rapport',
  'running': 'en cours',
  'No refresh has run yet.': 'Aucune actualisation n’a encore eu lieu.',
  'Could not load the refreshes: {error}': 'Impossible de charger les actualisations : {error}',
  'entries resolved': 'entrées résolues',
  'entries proposed': 'entrées proposées',
  'claims held on arrival': 'tenues à l’arrivée',
  'claims waiting in Review': 'en attente dans Revue',
  'anomalies': 'anomalies',
  'This refresh has not finished yet.': 'Cette actualisation n’est pas encore terminée.',
  'name': 'nom',
  'category': 'catégorie',
  'locality': 'localité',
  'state': 'état',
  'unresolved': 'non résolu',
  'ambiguous': 'ambigu',
  'proposed': 'proposé',
  'failed': 'échoué',
  'Nothing waiting — every named entry is either resolved or on the record.':
    'Rien en attente — chaque entrée nommée est soit résolue, soit au dossier.',
  'Could not load the waiting entries: {error}': 'Impossible de charger les entrées en attente : {error}',
  'not collected': 'non collecté',
  'settings': 'réglages',
  'last report': 'dernier rapport',
  'Refresh all requested.': 'Actualisation générale demandée.',
  '{key}: {outcome}': '{key} : {outcome}',
  'Filed {ref}.': '{ref} déposé.',
  'gone since last vintage': 'disparu depuis la dernière version',
  'The organisation, its facts and its links are untouched — a refresh retracts nothing.': 'L’organisation, ses faits et ses liens restent intacts — une actualisation ne retire rien.',
  'Could not load the entries that left: {error}': 'Les entrées disparues n’ont pas pu être chargées : {error}',
  'Every name a source printed before, it prints still.': 'Chaque nom qu’une source imprimait auparavant, elle l’imprime encore.',
  'gone': 'disparu',
  'held': 'tenu',
  'matched': 'apparié',
}, 'SourcesPage');
